import { SDKError } from './SDKError';
export var ErrorCode;
(function (ErrorCode) {
    // 4xx Client Errors
    ErrorCode["BadRequest"] = "BAD_REQUEST";
    ErrorCode["Unauthorized"] = "UNAUTHORIZED";
    ErrorCode["Forbidden"] = "FORBIDDEN";
    ErrorCode["NotFound"] = "NOT_FOUND";
    ErrorCode["MethodNotAllowed"] = "METHOD_NOT_ALLOWED";
    ErrorCode["RequestTimeout"] = "REQUEST_TIMEOUT";
    ErrorCode["Conflict"] = "CONFLICT";
    ErrorCode["Gone"] = "GONE";
    ErrorCode["UnsupportedMediaType"] = "UNSUPPORTED_MEDIA_TYPE";
    ErrorCode["TooManyRequests"] = "TOO_MANY_REQUESTS";
    // General errors
    ErrorCode["NetworkError"] = "NETWORK_ERROR";
    ErrorCode["NetworkDisconnected"] = "NETWORK_DISCONNECTED";
    ErrorCode["InvalidRequest"] = "INVALID_REQUEST";
    ErrorCode["CorsError"] = "CORS_ERROR";
    ErrorCode["TimeoutError"] = "TIMEOUT_ERROR";
    ErrorCode["ServerError"] = "SERVER_ERROR";
    ErrorCode["ClientError"] = "CLIENT_ERROR";
    ErrorCode["SslError"] = "SSL_Error";
    // 5xx Server Errors
    ErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ErrorCode["NotImplemented"] = "NOT_IMPLEMENTED";
    ErrorCode["BadGateway"] = "BAD_GATEWAY";
    ErrorCode["ServiceUnavailable"] = "SERVICE_UNAVAILABLE";
    ErrorCode["GatewayTimeout"] = "GATEWAY_TIMEOUT";
    ErrorCode["HttpVersionNotSupported"] = "HTTP_VERSION_NOT_SUPPORTED";
    ErrorCode["UndefinedError"] = "UNDEFINED_ERROR";
})(ErrorCode || (ErrorCode = {})); // Import your ErrorCode enum
export function mapStatusCodeToErrorCode(statusCode) {
    switch (statusCode) {
        case 400:
            return ErrorCode.BadRequest;
        case 401:
            return ErrorCode.Unauthorized;
        case 403:
            return ErrorCode.Forbidden;
        case 404:
            return ErrorCode.NotFound;
        case 405:
            return ErrorCode.MethodNotAllowed;
        case 408:
            return ErrorCode.RequestTimeout;
        case 409:
            return ErrorCode.Conflict;
        case 410:
            return ErrorCode.Gone;
        case 415:
            return ErrorCode.UnsupportedMediaType;
        case 429:
            return ErrorCode.TooManyRequests;
        case 500:
            return ErrorCode.InternalServerError;
        case 501:
            return ErrorCode.NotImplemented;
        case 502:
            return ErrorCode.BadGateway;
        case 503:
            return ErrorCode.ServiceUnavailable;
        case 504:
            return ErrorCode.GatewayTimeout;
        case 505:
            return ErrorCode.HttpVersionNotSupported;
        default:
            return ErrorCode.UndefinedError; // Return undefined for unhandled status codes
    }
}
export function handleXHRError(xhr, reject) {
    if (xhr.status === 0) {
        if (!navigator.onLine) {
            // Network Disconnection
            reject(new SDKError(ErrorCode.NetworkDisconnected));
        }
        else if (xhr.readyState === 1 || xhr.readyState === 4) {
            // DNS Failure or Invalid URL
            reject(new SDKError(ErrorCode.InvalidRequest));
        }
        else {
            // CORS Issues or Proxy Blocking
            reject(new SDKError(ErrorCode.CorsError));
        }
    }
    else if (xhr.readyState === 4) {
        if (xhr.status === 408) {
            // Timeout Error
            reject(new SDKError(ErrorCode.TimeoutError));
        }
        else if (xhr.status >= 500) {
            // Server Errors
            reject(new SDKError(ErrorCode.ServerError));
        }
        else if (xhr.status >= 400) {
            // Client Errors
            reject(new SDKError(ErrorCode.ClientError));
        }
        else {
            // Unknown error with valid status
            reject(new SDKError(ErrorCode.UndefinedError));
        }
    }
    else if (xhr.readyState === 0) {
        // for SSL Errors
        reject(new SDKError(ErrorCode.SslError));
    }
    else {
        // Catching for unhandled cases
        reject(new SDKError(ErrorCode.UndefinedError));
    }
}
//# sourceMappingURL=ErrorCode.js.map